

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { text } = colors;
const { size, fontWeightMedium, families } = typography;

const formControlLabel = {
  styleOverrides: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      gap: pxToRem(8),
      marginLeft: 0,
      marginRight: pxToRem(16),
      marginTop: 0,
      marginBottom: pxToRem(4),
      verticalAlign: "middle",
    },

    label: {
      fontFamily: families?.body,
      fontSize: size.sm,
      fontWeight: fontWeightMedium,
      color: text.main,
      lineHeight: 1.5,
      marginLeft: 0,
      marginRight: 0,

      "&.Mui-disabled": {
        color: text.focus,
        opacity: 0.6,
      },
    },
  },
};

export default formControlLabel;
